module.exports = __webpack_public_path__ + "img/icon-work-s.0f6a4470.png";